import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';
import HeadlineActionBand from './HeadlineActionBand';

/**
 * HeadlineBand · the standing, always-present plain-language read of whatever
 * view the operator is on (handoffV5 §12.2). Leads with what the data MEANS,
 * plus a rule-bound recommended action when a decision rule fires.
 *
 * - `view`: engine id ("engine:3") or sub-tab/intervention id ("capacity_utilization").
 * - `state`: the live metrics the view is showing — the headline reflects these.
 *
 * Distinct from <SimulationOutput/>: that is the 4-part Move Brief a simulation
 * RUN produces; this band is on every engine and sub-tab.
 */
export default function HeadlineBand({
  view,
  state,
  readOnlyAction = false,
}: {
  view: string;
  state: Record<string, unknown>;
  readOnlyAction?: boolean;
}) {
  const q = useQuery({
    queryKey: ['interpretation', view, state],
    queryFn: () => api.interpretationHeadline(view, state),
    // headline is derived from state; safe to keep while state is stable
    staleTime: 30_000,
  });
  if (!q.data) {
    // Quiet placeholder; never blocks the working content below
    return null;
  }
  const { headline_plain, recommended_action } = q.data;

  return (
    <HeadlineActionBand
      view={view}
      state={state}
      headline={headline_plain}
      action={recommended_action}
      readOnlyAction={readOnlyAction}
    />
  );
}
